import React from 'react';
import { Badge } from '@/components/ui/badge';
import { statusBadgeClass } from '@/lib/format';

export function StatusBadge({ status, ...props }) {
    const display = (status || 'unknown').toString().replace(/_/g, ' ');
    return (
        <Badge variant="outline" className={`capitalize border ${statusBadgeClass(status)}`} {...props}>
            {display.toLowerCase()}
        </Badge>
    );
}
